import { PoliciesEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const create = async (data: any): Promise<any> =>
  APIManager.sendPost(PoliciesEnds.CREATE, data, true, {}, {}, axios);

const getAll = async (queryString: string): Promise<any> =>
  APIManager.sendGet(PoliciesEnds.GET_ALL(queryString), true, {}, {}, axios);

const update = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(PoliciesEnds.UPDATE(id), data, true, {}, {}, axios);

const detail = async (id: string): Promise<any> =>
  APIManager.sendGet(PoliciesEnds.DETAIL(id), true, {}, {}, axios);

const deleteRecord = async (id: string): Promise<any> =>
  APIManager.sendDelete(PoliciesEnds.DELETE(id), true, {}, {}, axios);

// Policy Acknowledgement
const createAcknowledgement = async (data: any): Promise<any> =>
  APIManager.sendPost(PoliciesEnds.CREATE_ACK, data, true, {}, {}, axios);

const getAcknowledgements = async (id: string): Promise<any> =>
  APIManager.sendGet(PoliciesEnds.GET_ACK_LIST(id), true, {}, {}, axios);

const acknowledgePolicy = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(PoliciesEnds.ACK_POLICY(id), data, false, {}, {}, axios);

const deleteAcknowledgePolicy = async (id: string): Promise<any> =>
  APIManager.sendDelete(
    PoliciesEnds.DELETE_ACK_POLICY(id),
    true,
    {},
    {},
    axios
  );

const policyByAckId = async (id: string): Promise<any> =>
  APIManager.sendGet(PoliciesEnds.POLICY_BY_ACK_ID(id), false, {}, {}, axios);

// Policy Approvals
const addApprover = async (data: any): Promise<any> =>
  APIManager.sendPost(PoliciesEnds.ADD_APPROVER, data, true, {}, {}, axios);

const approvers = async (id: string): Promise<any> =>
  APIManager.sendGet(PoliciesEnds.APPROVERS(id), true, {}, {}, axios);

const deleteApprover = async (id: string): Promise<any> =>
  APIManager.sendDelete(PoliciesEnds.DELETE_APPROVER(id), true, {}, {}, axios);

const approvePolicy = async (id: string): Promise<any> =>
  APIManager.sendPost(PoliciesEnds.APPROVE_POLICY(id), {}, true, {}, {}, axios);

const reviewPolicy = async (id: string, data: any): Promise<any> =>
  APIManager.sendPost(
    PoliciesEnds.REVIEW_POLICY(id),
    data,
    true,
    {},
    {},
    axios
  );

const reviewHistory = async (id: string): Promise<any> =>
  APIManager.sendGet(PoliciesEnds.REVIEW_HISTORY(id), true, {}, {}, axios);

const policyTemplates = async (): Promise<any> =>
  APIManager.sendGet(
    PoliciesEnds.COMPLIANCE_POLICY_TEMPLATES,
    true,
    {},
    {},
    axios
  );

const addFrameworkToPolicy = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(
    PoliciesEnds.ADD_POLICY_FRAMEWORK(id),
    data,
    true,
    {},
    {},
    axios
  );

const policyCompliancTracking = async (): Promise<any> =>
  APIManager.sendGet(
    PoliciesEnds.POLICY_COMPLIANCES_TRACKING,
    true,
    {},
    {},
    axios
  );

const getComplianceTracking = async (): Promise<any> =>
  APIManager.sendGet(
    PoliciesEnds.GET_COMPLIANCES_TRACKING,
    true,
    {},
    {},
    axios
  );

const createComplianceTracking = async (data: any): Promise<any> =>
  APIManager.sendPost(
    PoliciesEnds.CREATE_COMPLIANCES_TRACKING,
    data,
    true,
    {},
    {},
    axios
  );

const updateComplianceTracking = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(
    PoliciesEnds.UPDATE_COMPLIANCES_TRACKING(id),
    data,
    true,
    {},
    {},
    axios
  );

const healthCheck = async (healthId: any): Promise<any> =>
  APIManager.sendPost(
    PoliciesEnds.HEALTH_CHECK(healthId),
    {},
    true,
    {},
    {},
    axios
  );

const getPolicyVersion = async (id: string): Promise<any> =>
  APIManager.sendGet(PoliciesEnds.GET_POLICY_VERSION(id), true, {}, {}, axios);

const getAllApprovals = async (): Promise<any> =>
  APIManager.sendGet(PoliciesEnds.APPROVAL_GATES, true, {}, {}, axios);

const getApproval = async (id: string): Promise<any> =>
  APIManager.sendGet(
    PoliciesEnds.APPROVAL_GATES_BY_ID(id),
    true,
    {},
    {},
    axios
  );

const addApprovalGate = async (data: any): Promise<any> =>
  APIManager.sendPost(
    PoliciesEnds.ADD_APPROVAL_GATE,
    data,
    true,
    {},
    {},
    axios
  );

const deleteApprovalGate = async (id: string): Promise<any> =>
  APIManager.sendDelete(
    PoliciesEnds.DELETE_APPROVAL_GATE(id),
    true,
    {},
    {},
    axios
  );

const updateApprovalGate = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(
    PoliciesEnds.UPDATE_APPROVAL_GATE(id),
    data,
    true,
    {},
    {},
    axios
  );

const createComplianceAttachment = async (data: any): Promise<any> =>
  APIManager.sendPost(
    PoliciesEnds.CREATE_COMPLIANCES_ATTACHMENT,
    data,
    true,
    {},
    {},
    axios
  );

const deleteComplianceAttachment = async (id: string): Promise<any> =>
  APIManager.sendDelete(
    PoliciesEnds.DELETE_COMPLIANCES_ATTACHMENT(id),
    true,
    {},
    {},
    axios
  );

const downloadAttachment = async (id: string): Promise<any> =>
  APIManager.sendPost(
    PoliciesEnds.COMPLIANCES_ATTACHMENT_DOWNLOAD(id),
    {},
    true,
    {},
    {},
    axios
  );

export const PoliciesService = {
  create,
  getAll,
  update,
  detail,
  deleteRecord,
  createAcknowledgement,
  getAcknowledgements,
  acknowledgePolicy,
  deleteAcknowledgePolicy,
  policyByAckId,
  addApprover,
  approvers,
  deleteApprover,
  approvePolicy,
  reviewPolicy,
  reviewHistory,
  policyTemplates,
  addFrameworkToPolicy,
  policyCompliancTracking,
  getComplianceTracking,
  createComplianceTracking,
  updateComplianceTracking,
  healthCheck,
  getPolicyVersion,
  getAllApprovals,
  getApproval,
  addApprovalGate,
  deleteApprovalGate,
  updateApprovalGate,
  createComplianceAttachment,
  deleteComplianceAttachment,
  downloadAttachment,
};
